module.exports = __webpack_public_path__ + "img/portrait_v2.e4a5213.png";